export default function Watermark() {
  return (
    <div
      className="fixed inset-0 pointer-events-none z-[1] flex items-center justify-center select-none"
      aria-hidden="true"
    >
      <span className="font-heading font-bold text-black opacity-[0.04] select-none whitespace-nowrap -rotate-12"
        style={{ fontSize: "clamp(120px, 20vw, 280px)" }}>
        崧燁文化
      </span>
    </div>
  );
}